import { http } from '@pendo/http';
import { getImageFileType } from '@/common/image-upload/image-upload.utils';

const multipartHeaders = { 'Content-Type': 'multipart/form-data' };

function normalizeMediaUploadResponse (data) {
    if (!data) {
        return null;
    }

    return {
        ...data,
        mediaFileId: data.mediaFileId ?? data.id,
    };
}

function createImageUploadFormData (imageFile, { altText } = {}) {
    const formData = new FormData();
    formData.append('file', imageFile);

    if (imageFile?.name) {
        formData.append('fileName', imageFile.name);
    }

    const fileType = getImageFileType(imageFile);
    if (fileType) {
        formData.append('fileType', fileType);
    }

    if (altText !== undefined) {
        formData.append('altText', altText);
    }

    return formData;
}

export function createVocItemMedia (vocItemId, mediaType, { altText, imageFile } = {}) {
    const formData = createImageUploadFormData(imageFile, { altText: altText ?? '' });

    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/media/${mediaType}/file`, formData, {
            headers: multipartHeaders,
        })
        .then((res) => normalizeMediaUploadResponse(res.data))
        .catch((err) => {
            throw err;
        });
}

export function createVocMedia (mediaType, imageFile) {
    const formData = createImageUploadFormData(imageFile);

    return http
        .post(`/api/s/_SID_/voc/mediaFile/${mediaType}/file`, formData, {
            headers: multipartHeaders,
        })
        .then((res) => normalizeMediaUploadResponse(res.data))
        .catch((err) => {
            throw err;
        });
}

export function createAttachmentMedia (vocItemId, fileName, fileType) {
    return http
        .post(
            `/api/s/_SID_/vocItem/${vocItemId}/media/attachment`,
            { fileType, fileName },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function addAttachmentToVocItem (vocItemId, attachmentId) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/attachment/${attachmentId}`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchAttachmentUrl (vocItemId, attachmentId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/media/attachment/${attachmentId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchBannerImageUrl (vocItemId, bannerImageId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/media/bannerImage/${bannerImageId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateBannerImageAltText (vocItemId, bannerImageId, altText) {
    return http
        .put(`/api/s/_SID_/vocItem/${vocItemId}/media/${bannerImageId}`, { altText })
        .then((res) => res?.data)
        .catch((err) => {
            throw err;
        });
}

export async function copyVocItemMedia ({ guideId, vocItemId, mediaFileType, mediaFileId }) {
    return http.post(`/api/s/_SID_/vocItem/${vocItemId}/media/${mediaFileType}/${mediaFileId}/publish`, {
        guideId,
    });
}

export function deleteAttachment (vocItemId, attachmentId) {
    return http.delete(`/api/s/_SID_/vocItem/${vocItemId}/attachment/${attachmentId}`).catch((err) => {
        throw err;
    });
}

export function getDefaultBannerImage () {
    return http
        .get('/api/s/_SID_/vocItem/emailUpdateDefaultCoverImage')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateDefaultBannerImage ({ vocItemId, mediaFileId }) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/vocItemUpdate/defaultCoverImage`, {
            mediaFileId,
        })
        .catch((err) => {
            throw err;
        });
}
